const JuiceProduct = {
  IsBroadband: true,
  JuiceFlavor: '',
  BlendFlavor: '',
  VitaminCCertification: false,
  OneHundredPercentJuiceCertification: false,
  FrontLabelCertification: false,
  ContainerType: '64 oz shelf-stable only',
}

export default JuiceProduct
